/**
 * Variables de entorno
 */
const redirectUri = import.meta.env.VITE_REDIRECT_URI;
const clientId = import.meta.env.VITE_CLIENT_ID;
const scope = import.meta.env.VITE_SCOPE;
const postLogoutRedirectUri = import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI;
import * as msal from "@azure/msal-browser";

/**
 * Policies for B2C application
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1_susi_v2',
        forgotPassword: 'B2C_1_reset_v3',
        editProfile: 'B2C_1_edit_profile_v2',
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://login.microsoftonline.com/30138403-120d-4f4f-864e-2ea2c26e6a70/B2C_1_susi_v2',
        },
        forgotPassword: {
            authority: 'https://login.microsoftonline.com/30138403-120d-4f4f-864e-2ea2c26e6a70/B2C_1_reset_v3',
        },
        editProfile: {
            authority: 'https://login.microsoftonline.com/30138403-120d-4f4f-864e-2ea2c26e6a70/B2C_1_edit_profile_v2',
        },
    },
    authorityDomain: 'login.microsoftonline.com',
};

/**
 * MSAL configuration
 */
export const msalConfig = {
    auth: {
        clientId: clientId,  // Usando la variable de entorno
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: redirectUri,  // Usando la variable de entorno
        postLogoutRedirectUri: postLogoutRedirectUri, // Desde el entorno
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case msal.LogLevel.Error:
                        console.error(message);
                        break;
                    case msal.LogLevel.Info:
                        //console.info(message);
                        break;
                    case msal.LogLevel.Verbose:
                        console.debug(message);
                        break;
                    case msal.LogLevel.Warning:
                        console.warn(message);
                        break;
                }
            },
        },
    },
};

/**
 * Configuración de login con MSAL
 */
export const loginRequest = {
    scopes: [scope], // Usando la variable de entorno
};

export const graphRequest = {
    scopes: ["https://graph.microsoft.com/User.Read"],
};

// Instancia global de MSAL
export const msalInstance = new msal.PublicClientApplication(msalConfig);

/**
 * Función para verificar si el token ha expirado.
 * Utiliza el claim 'exp' del idToken y, en caso de expirado, fuerza el logout.
 */
export function checkTokenExpiry() {
    const account = msalInstance.getActiveAccount();
    const currentPath = window.location.pathname
    
    if (!account || !account.idTokenClaims?.exp) {
        //console.warn("No se encontró un token válido. Redirigiendo a /auth/login...");
        if (currentPath !== '/auth/login') {
            //console.warn("Redirigiendo a /auth/login...");
            window.location.href = '/auth/login';
        }
        return;
    }

    const expiryTime = account.idTokenClaims.exp * 1000; // Convertimos a milisegundos
    const currentTime = Date.now(); // Tiempo actual en milisegundos

    // console.log("Tiempo de expiración del token:", new Date(expiryTime));
    // console.log("Tiempo actual:", new Date(currentTime));
    // console.log("Tiempo restante (ms):", expiryTime - currentTime);

    if (currentTime >= expiryTime) {
        //console.warn("El token ha expirado. Cerrando sesión y redirigiendo a /auth/login...");

        // Limpiar sesión antes de redirigir
        sessionStorage.clear();

        // Llamar a logout() dentro de un hook React
        import('./src/components/context/AuthContext').then(({ useAuth }) => {
            const { logout } = useAuth();
            logout();
        });

        // Redirigir al login
        window.location.href = '/auth/login';
    } else {
        //console.log("El token aún es válido.");
    }
}


  
  
